export default __webpack_public_path__ + "static/media/Unaccessed2.4ac45089.svg";